import type { ModuleManifest } from "./types";

export const processingActivitiesManifest: ModuleManifest = {
  name: "processing-activities",
  label: "Attività di Trattamento",
  labelPlural: "Attività di Trattamento",
  coreBOSModule: "ProcessingActivities",
  wsidPrefix: "71x",
  type: "standard",
  routes: {
    list: "/processing-activities",
    show: "/processing-activities/show/:id",
    create: "/processing-activities/create",
    edit: "/processing-activities/edit/:id",
  },
  navigation: {
    icon: "DatabaseOutlined",
    order: 10,
    group: "Security",
  },
  routing: {
    keywords: ["processing", "trattamento", "trattamenti", "art30", "registro"],
    searchFields: ["processingname", "id_trattamento"],
    defaultSort: { field: "processingname", order: "asc" },
  },
  context: { supported: true, entityKey: "processing-activities" },
  fields: [
    { name: "processingname", label: "Nome Trattamento", type: "string", required: true },
    { name: "id_trattamento", label: "Codice (DB)", type: "string" },
    { name: "rel_account", label: "Account", type: "reference" },
    { name: "purpose_of_processing", label: "Finalità", type: "text" },
    { name: "legal_basis", label: "Base Giuridica", type: "picklist" },
    { name: "categories_of_data_subjects", label: "Categorie Interessati", type: "text" },
    { name: "is_template", label: "Template", type: "boolean" },
    { name: "assigned_user_id", label: "Assegnato a", type: "reference" },
  ],
  relationships: [
    { module: "Accounts", field: "rel_account", label: "Account", icon: "BankOutlined", displayField: "accountname" },
  ],
  requiredFields: ["processingname"],
  viewStrategy: "bespoke",
};
